import { clsx } from 'clsx';
import { TabsContent } from 'src/components/ui/tabs';
import React from 'react';
import { PersonaTabSkeleton } from 'src/pages/ConfigurationPage/PersonaTab/PersonaTabSkeleton/PersonaTabSkeleton';
import { LoaderWrapper } from 'src/components/LoaderWrapper/LoaderWrapper';
import { WorkflowsForm } from 'src/pages/ConfigurationPage/WorkflowsTab/WorkflowsForm/WorkflowsForm';

export const WorkflowsTab = ({
  isLoading,
  submit = () => {},
  formFieldsObject = {} as Record<string, any>,
  readonly,
  onWorkflowsChange = (() => {}) as (key: any, data: any) => void,
  onWorkflowAdd = (() => {}) as (workflow: any) => void,
  onEditClick = () => {},
  defaultWorkflows,
  customWorkflows,
}: {
  isLoading?: boolean;
  submit?: () => void;
  formFieldsObject?: Record<string, any>;
  readonly?: boolean;
  onWorkflowsChange?: (key: any, data: any) => void;
  onWorkflowAdd?: (workflow: any) => void;
  onEditClick?: () => void;
  defaultWorkflows?: any;
  customWorkflows?: any;
}) => {
  const formFieldsLength = Object.keys(formFieldsObject).length;

  return (
    <TabsContent
      className={clsx('p-0 mt-0 h-full rounded-sm-5 overflow-auto pr-2')}
      value={'workflows'}
    >
      <LoaderWrapper isLoading={isLoading} loader={<PersonaTabSkeleton />}>
        {Boolean(formFieldsLength) ? (
          <WorkflowsForm
            onWorkflowsChange={onWorkflowsChange}
            onWorkflowAdd={onWorkflowAdd}
            onEditClick={onEditClick}
            defaultWorkflows={defaultWorkflows}
            customWorkflows={customWorkflows}
            formFieldsObject={formFieldsObject}
            readonly={readonly}
            compact={true}
          />
        ) : (
          <div
            className={
              'bg-[#F5FCFE] rounded-sm-5 border border-[#009CB240] flex items-center justify-center p-7.5'
            }
          >
            <p className={'text-center text-base font-medium text-[#009CB2]'}>
              Custom configuration by CoSupport AI.
              <br /> To request edits, reach out to your Account Manager.
            </p>
          </div>
        )}
      </LoaderWrapper>
    </TabsContent>
  );
};
